import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DoctorsService} from '../../services/doctors.service';
import {DoctorDataModel} from '../../models/doctors/doctor-data.model';
import {DataAppointmentModel} from '../../models/appointments/data-appointment.model';
import {DoctorQueryOptionsModel} from '../../models/doctors/doctor-query-options.model';
import {EnumValidValueItemModel} from "../../models/enum/enum-valid-value-item.model";
import {StaticDataService} from "../../services/static-data.service";
import {NotesService} from "../../services/notes.service";
import {TdoNoteQueryModel} from "../../main-interface/controls/tdo-notes/models/tdo-note-query.model";
import {Globals} from "../../globals";

@Component({
  selector: 'app-patient-appointment-detail-dialog',
  templateUrl: './patient-appointment-detail-dialog.component.html',
  styleUrls: ['./patient-appointment-detail-dialog.component.scss']
})
export class PatientAppointmentDetailDialogComponent implements OnInit {
  doctors: DoctorDataModel[] = [];
  appointmentTypeEnums: EnumValidValueItemModel[] = [];
  appointmentStatusEnums: EnumValidValueItemModel[] = [];

  constructor(private dialogRef: MatDialogRef<PatientAppointmentDetailDialogComponent>,
              private globals: Globals,
              private noteService: NotesService,
              private staticDataService: StaticDataService,
              @Inject(MAT_DIALOG_DATA) public data: DataAppointmentModel,
              private doctorService: DoctorsService) { }

  ngOnInit(): void {
    const options = new DoctorQueryOptionsModel();
    options.isIncludeReferring = true;
    options.isIncludeTdo = true;
    this.doctorService.getDoctors(options).subscribe((res) => {
      this.doctors = res;
    });

    if (this.staticDataService.isReady) {
      this.appointmentTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumApptType');
      this.appointmentStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumApptStatus');
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.appointmentTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumApptType');
          this.appointmentStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumApptStatus');
        }
      });
    }
  }

  onOkClick() {
    this.dialogRef.close();
  }

  getReferringDoctor() {
    if (this.data.dataAppoitmentDetails) {
      const docId = this.data.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId' || p.DetailParameterName === 'referringDoctorId');
      if (docId) {
        const doc = this.doctors.find(p => p.DoctorId.toLowerCase() === docId.DetailParameterValue.toLowerCase());
        if (doc) {
          return 'Dr. ' + doc.dataContact.LastName;
        }
      }
    }
  }

  getDoctor() {
    const doc = this.doctors.find(p => p.DoctorId.toLowerCase() === this.data.Label_DoctorId.toLowerCase());
    if (doc) {
      return 'Dr. ' + doc.dataContact.LastName;
    }

    return '';
  }

  getType() {
    if (this.data.enumApptTypeId) {
      const enu = this.appointmentTypeEnums.find(p => p.ValidValueItemId.toLowerCase() === this.data.enumApptTypeId.toLowerCase());
      if (enu) {
        return enu.ItemDisplayValue;
      }
    }

    return '';
  }

  getStatus() {
    if (this.data.enumApptStatusId) {
      const enu = this.appointmentStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === this.data.enumApptStatusId.toLowerCase());
      if (enu) {
        return enu.ItemDisplayValue;
      }
    }

    return '';
  }
}
